import React from "react";
import { NodeProps, useReactFlow } from "reactflow";
import { operationType } from "../../../../../services/types";
import { SettingsBlock, settingsDataType } from "../../../../settingsBlock";
import { ExpandedBlock } from "../../../expanded";
import {  updateNodeValue } from "../../../../../services/method";
import { Main, Styled } from "./style";
import { TextInput } from "../../../../form/textInput";
import { Textarea } from "../../../../form/textarea";
import { IoCheckmarkCircleOutline, IoWarningOutline } from "react-icons/io5";

type MessengerSendMessageProps = NodeProps<operationType> & {
  setChildMinimize?: (fn: (id: string) => void) => void;
  setChildSettings?: (fn: (id: string) => void) => void;
};

export function MessengerSendMessage({
  id,
  data,
  setChildMinimize,
  setChildSettings,
}: MessengerSendMessageProps) {
  const { setNodes } = useReactFlow();
  const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
  const [isExpanded, setIsExpanded] = React.useState(false);

  React.useEffect(() => {
    if (setChildMinimize) setChildMinimize(() => setIsExpanded((p) => !p));
    if (setChildSettings) setChildSettings(() => setSettings((p) => ({ ...p, isToggle: !p.isToggle })));
  }, [setChildMinimize, setChildSettings]);

  const handleChangeInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    keyRef?: string
  ) => keyRef && updateNodeValue(id, setNodes, { [keyRef]: e.target.value });

  let isWarning = !data.value?.pageAccessToken || !data.value?.messageText;
  isWarning = false
  
  return (
    <>
      <SettingsBlock nodeId={id} data={settings} setData={setSettings} />
      <Main>
        {isWarning ? <>
          <div id="warning"></div>
          <span id="warningIcon"><IoWarningOutline size={21} /></span>
        </> : data.output ? <>
          <div id="ran"></div>
          <span id="ranIcon"><IoCheckmarkCircleOutline size={ 21 } /></span>
        </> : null}
        {isExpanded && (
          <ExpandedBlock
            data={{ id, ...data }}
            handleClose={() => setIsExpanded(false)}
            style={{ minWidth: "420px" }}
            isWarning={false}
          >
       
            <Styled>

              {/* <TextInput
                keyRef="sender_id"
                value={data.value?.sender_id || ""}
                title="Sender ID"
                placeholder="User"
                handleChange={handleChangeInput}
                /> */}
                <div style={{marginBottom: '10px'}}>


              <TextInput
                keyRef="pageAccessToken"
                value={data.value?.pageAccessToken || ""}
                title="Token"
                placeholder="Enter Page Access Token"
                handleChange={handleChangeInput}
                />
                </div>
                
              <Textarea
                keyRef="messageText"
                value={data.value?.messageText || ""}
                // title="Message Text"
                placeholder="Type message..."
                handleChange={handleChangeInput}
                />
            </Styled>
          </ExpandedBlock>
        )}
      </Main>
    </>
  );
}